import { Component, Host, h, Prop, State, Watch } from '@stencil/core';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import _ from 'lodash';

@Component({
  tag: 'nypmegemenu-component',
  styleUrl: 'nypmegemenu-component.css',
  scoped: true
})
export class NypmegemenuComponent {

  /**
 *Required - Unique ID.
 */
  @Prop() componentid: string = "comp-id";

  /**
  *Required - List Name.
  */
  @Prop() listname: string = "ListName";

  /**
  *Required - Relative to the root site. no trailing slash. for ex: /hr/pm
  */
  @Prop() webpath: string = "/";

  /**
  *Required - if header attribute is true
  */
  @Prop() sectiontitle: string = "Section Title";

  /**
  *Required - if header attribute is true
  */
  @Prop() titleiconurl: string = "";

  /**
   *Optional - image location - left, right,top or bottom
   */
  @Prop() imagepos: string = "none";

  /**
   *Optional - image col span  if image pos is  left or  right. default is 3
   */
  @Prop() imagecolspan: number = 3;


  /**
   *Optional - To show/hide header - default is true
   */
  @Prop() header: boolean = true;

  /**
 *Optional - vertical scroll bar
 */
  @Prop() verticalscroll: boolean = false;

  /**
 *Optional - vertical scroll bar height
 */
  @Prop() verticalscrollheight: number = 200;


  /**
*Optional - header background color
*/
  @Prop() headerbgcolor: string = "white"

  /**
*Optional -header text color
*/
  @Prop() headertextcolor: string = "black"
  /**
*Optional -header border bottom css
*/
  @Prop() headerborderbottom: string = "1px solid #CE2127"

  /**
*Optional -embeded video true or false
*/
  @Prop() embededvideo: boolean = false

  /**
*Optional - is it SP Online site
*/
  @Prop() online: boolean = false;

  /**
  *Required - site url if its sp online site
  */
  @Prop() siteurl: string = "";



  @State() isLoading: boolean = true
  @State() items: []

  componentDidLoad() {

    // const siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl;


    let siteUrl: string = "";
    if ((window as any)._spPageContextInfo != null) {
      siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl + this.webpath;
    }
    else {
      let domain = new URL(window.location.href)
      siteUrl = domain.origin + this.webpath
    }


    const filter = "ShowInMenu eq 1";

    return fetch(siteUrl + "/_api/web/lists/getbytitle('" + this.listname + "')/items?$select=ID,Title,ItemUrl,ShowInMenu,ItemOrder,MenuSection,SectionContent,MenuType&$filter=" + filter + "&$orderby=ItemOrder&$top=1000", { headers: { "Accept": "application/json; odata=verbose" } })
      .then(response => response.json())
      .then(data => {
        this.items = data.d.results;
        this.isLoading = false;
      });
  }


  fixBody = (bodystring: string) => {

    let parser = new DOMParser();
    let domNode = parser.parseFromString(bodystring, "text/html");
    const img = domNode.querySelectorAll("img");
    const tables = domNode.querySelectorAll("table");
    const videos = domNode.querySelectorAll("video");

    for (let i = 0; i < img.length; i++) {
      img[i].classList.add("sc-nypmegemenu-component", "img-fluid", "rounded");
    }

    if (this.embededvideo) {
      for (let i = 0; i < videos.length; i++) {
        videos[i].setAttribute("controls", "controls")
      }
    }

    for (let i = 0; i < tables.length; i++) {
      tables[i].classList.add("sc-nypmegemenu-component", "table");
    }

    for (let i = 0; i < tables.length; i++) {
      let parent = tables[i].parentNode;
      let divWrapper = document.createElement("div");
      divWrapper.classList.add("sc-nypmegemenu-component", "table-responsive", "tableborder")
      parent.replaceChild(divWrapper, tables[i]);
      divWrapper.appendChild(tables[i]);
    }

    return domNode.body.innerHTML;

  }

  getContents = () => {


    const contentsArray1 = []
    let menutypes = _.uniq(_.map(this.items, 'MenuType'))

    menutypes.forEach((element, index) => {


      const left = []
      const center1 = []
      const center2 = []
      const right = []

      let menuItemsLeft = []
      let menuItemsCenter1 = []
      let menuItemsCenter2 = []
      let menuItemsRight = [];

      console.log(element + "," + index);

      menuItemsLeft = _.filter(this.items, function (n: any) {

        return n.MenuType === element && n.MenuSection === "Left";
      });

      menuItemsLeft.forEach((menu) => {
        if (menu.SectionContent) {
          left.push(
            <p > <div class="raw-html-style" innerHTML={this.fixBody(menu.SectionContent)} /> </p>
          )
        }
        else {
          left.push(
            <li><a class="dropdown-item" href={menu.ItemUrl.Url}>{menu.Title}</a></li>
          )
        }
      })

      menuItemsCenter1 = _.filter(this.items, function (n: any) {
        return n.MenuType === element && n.MenuSection === "Center 1";
      });

      menuItemsCenter1.forEach((menu) => {

        if (menu.SectionContent) {
          center1.push(
            <p > <div class="raw-html-style" innerHTML={this.fixBody(menu.SectionContent)} /> </p>
          )
        }
        else {
        center1.push(
          <li><a class="dropdown-item" href={menu.ItemUrl.Url}>{menu.Title}</a></li>
        )
      }
      })

      menuItemsCenter2 = _.filter(this.items, function (n: any) {
        return n.MenuType === element && n.MenuSection === "Center 2";
      });

      menuItemsCenter2.forEach((menu) => {
        if (menu.SectionContent) {
          center2.push(
            <p > <div class="raw-html-style" innerHTML={this.fixBody(menu.SectionContent)} /> </p>
          )
        }
        else {
        center2.push(
          <li><a class="dropdown-item" href={menu.ItemUrl.Url}>{menu.Title}</a></li>
        )
      }
      })


      menuItemsRight = _.filter(this.items, function (n: any) {
        return n.MenuType === element && n.MenuSection === "Right";
      });

      menuItemsRight.forEach((menu) => {
        if (menu.SectionContent) {
          right.push(
            <p > <div class="raw-html-style" innerHTML={this.fixBody(menu.SectionContent)} /> </p>
          )
        }
        else {
        right.push(
          <li><a class="dropdown-item" href={menu.ItemUrl.Url}>{menu.Title}</a></li>
        )
      }
      })


      // this.getMenu(element,menuArray);
      let id = "navbarDropdown-" + index

      contentsArray1.push(<li class="nav-item dropdown dropdown-mega position-static">
        <a class="nav-link dropdown-toggle" href="#" id={id} role="button" data-bs-toggle="dropdown"
          aria-expanded="false">
          {element}
        </a>
        <ul class="dropdown-menu" aria-labelledby="navbarDropdown" style={{ "width": "100%", "border": "0" }}>

          <div class="mega-content px-4" >
            <div class="container-fluid">

              <div class="row">
                <div class="col-12 col-sm-4 col-md-3 py-4">
                  {left} </div>
                <div class="col-12 col-sm-4 col-md-3 py-4">
                  {center1} </div>
                <div class="col-12 col-sm-4 col-md-3 py-4">
                  {center2} </div>
                <div class="col-12 col-sm-4 col-md-3 py-4">{right}</div>
              </div>
            </div>
          </div>
        </ul>
      </li>




      )

    })


    const contentsArray = (
      <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <div class="container-fluid">
          <a class="navbar-brand" href="#">Home</a>
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
              {contentsArray1}


            </ul>

          </div>
        </div>
      </nav>
    )
    return contentsArray
  }

  render() {


    return (
      this.isLoading ?
        <loader-component /> :
        <div >
          {this.getContents()}
          <h1>Megamenu2</h1>
        </div>

    )

  }
}
